import backendInstance from './axiosInstance';
import { notifyClientErrors } from '../common/AppUtils';
import { API_ERROR_MESSAGE } from '../common/AppConstants';
import logger from '../logger';

// Use httpRequest, this is raw util function
export const httpRequestUtil = async (
  method,
  url,
  data = {},
  config = {},
) => {
  try {
    const response = await backendInstance.request({
      method,
      url,
      ...(method.toUpperCase() === "GET"
        ? { params: data }   // query string
        : { data }),        // body for POST/PUT/PATCH
      ...config,
    });
    return response;

  } catch (error) {
    // Handle non 2xx responses
    if (error.response) {
      console.log(`Exception in API ${method} ${url} - ${error.response.status}`);
      throw error.response;
    }
    
    // Handle exceptions
    console.log(`Error in API ${method} ${url} - ${error}`);
    throw error;
  }
};

export const httpRequest = async ({
  method,
  url,
  data = {},
  config = {},
  onSuccess,
  onFailure,
  addNotification,
}) => {
  try {
    const response = await httpRequestUtil(method, url, data, config);
    onSuccess?.(response.data);
    return {
      success: true,
      status: response.status,
      data: response.data,
    };

  } catch (error) {
    const status = error?.status;
    
    // 4xx
    if (status >= 400 && status < 500) {
      if (addNotification){
        notifyClientErrors(error.data, addNotification);
      }
      onFailure?.(error.data);
      return { success: false, status: status, data: error.data };
    }

    // 5xx
    if (status >= 500) {
      addNotification?.(API_ERROR_MESSAGE.serverError, "error");
      return { success: false, status: status };
    }

    addNotification?.(API_ERROR_MESSAGE.networkError, "error");
    return { success: false };
  }
};
